var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJury(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7C8.44772 7 8 7.44772 8 8C8 10.2091 9.79086 12 12 12C14.2091 12 16 10.2091 16 8C16 7.44772 15.5523 7 15 7H9Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4C15.5 4.5388 15.3782 5.04917 15.1608 5.50509C15.9823 5.55722 16.696 6.00615 17.1124 6.66234C17.6477 6.30344 18 5.69287 18 5C18 3.89543 17.1046 3 16 3C15.7845 3 15.5769 3.03409 15.3824 3.09716C15.4591 3.38519 15.5 3.68782 15.5 4Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83924 5.50509C8.01771 5.55722 7.30399 6.00615 6.88759 6.66234C6.35233 6.30344 6 5.69287 6 5C6 3.89543 6.89543 3 8 3C8.21551 3 8.42306 3.03409 8.61755 3.09716C8.54087 3.38519 8.5 3.68782 8.5 4C8.5 4.5388 8.62175 5.04917 8.83924 5.50509Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8H5C4.44772 8 4 8.44772 4 9C4 11.2091 5.79086 13 8 13C8.45149 13 8.88551 12.9252 9.29034 12.7873C7.62417 11.8422 6.5 10.0524 6.5 8Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13C15.5485 13 15.1145 12.9252 14.7097 12.7873C16.3758 11.8422 17.5 10.0524 17.5 8H19C19.5523 8 20 8.44772 20 9C20 11.2091 18.2091 13 16 13Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.25C1.58579 14.25 1.25 14.5858 1.25 15C1.25 15.4142 1.58579 15.75 2 15.75H3V21.25H2C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25H21V15.75H22C22.4142 15.75 22.75 15.4142 22.75 15C22.75 14.5858 22.4142 14.25 22 14.25H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJury);
export default __webpack_public_path__ + "static/media/jury.ea14ea46aee407d502d6d438059cde69.svg";
export { ForwardRef as ReactComponent };